import React from 'react';

import { IconProps } from '../DefaultIcon';

/*
Icon for "Recrutamento" in the "Comercial" section of the main menu.
Icon for "./Comercial/Recrutamento/Colaradores"
 */
export function RecruitmentIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="79"
      viewBox="0 0 80 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2_348)">
        <path
          d="M76.3746 24.8943H31.4199C29.4864 24.8943 27.7946 26.5861 27.7946 28.5196V66.2236C27.7946 68.1571 29.4864 69.8489 31.4199 69.8489H67.432L77.5831 78.0665C78.5498 78.7915 80 78.0665 80 76.858V28.5196C80 26.5861 78.3082 24.8943 76.3746 24.8943Z"
          fill="#00C4B3"
        />
        <path
          d="M53.8973 48.3384C46.1632 48.3384 39.8792 54.139 38.9124 61.3897C38.6707 62.3565 39.6375 63.3233 40.6043 63.3233H67.1904C68.1572 63.3233 69.1239 62.3565 68.8822 61.3897C67.9155 54.139 61.6315 48.3384 53.8973 48.3384Z"
          fill="white"
        />
        <path
          d="M53.8972 51.7221C60.3044 51.7221 65.4984 46.528 65.4984 40.1208C65.4984 33.7137 60.3044 28.5196 53.8972 28.5196C47.4901 28.5196 42.296 33.7137 42.296 40.1208C42.296 46.528 47.4901 51.7221 53.8972 51.7221Z"
          fill="#00C4B3"
        />
        <path
          d="M62.1149 40.1208C62.1149 44.713 58.4895 48.3384 53.8973 48.3384C49.3052 48.3384 45.6798 44.713 45.6798 40.1208C45.6798 35.5287 49.3052 31.9033 53.8973 31.9033C58.4895 31.9033 62.1149 35.7704 62.1149 40.1208Z"
          fill="white"
        />
        <path
          d="M48.3384 0H3.62538C1.69184 0 0 1.69184 0 3.62538V51.9637C0 53.1722 1.45015 53.8973 2.41692 53.1722L12.568 44.9547H48.3384C50.2719 44.9547 51.9637 43.2628 51.9637 41.3293V3.62538C51.9637 1.69184 50.5136 0 48.3384 0Z"
          fill="#EAEEF9"
        />
        <path
          d="M26.5861 23.4441C18.8519 23.4441 12.5679 29.2447 11.6012 36.4955C11.3595 37.4622 12.3262 38.429 13.293 38.429H39.8791C40.8459 38.429 41.8126 37.4622 41.571 36.4955C40.6042 29.003 34.3202 23.4441 26.5861 23.4441Z"
          fill="#00416B"
        />
        <path
          d="M26.5861 26.8278C32.9932 26.8278 38.1873 21.6338 38.1873 15.2266C38.1873 8.81942 32.9932 3.62538 26.5861 3.62538C20.1789 3.62538 14.9849 8.81942 14.9849 15.2266C14.9849 21.6338 20.1789 26.8278 26.5861 26.8278Z"
          fill="#EAEEF9"
        />
        <path
          d="M34.8036 15.2266C34.8036 19.8187 31.1782 23.4441 26.5861 23.4441C21.9939 23.4441 18.3685 19.8187 18.3685 15.2266C18.3685 10.6344 21.9939 7.00906 26.5861 7.00906C31.1782 7.00906 34.8036 10.6344 34.8036 15.2266Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_348">
          <rect width="80" height="78.3082" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
